import React from 'react'
import style from './ValidationMessage.module.scss'

interface ValidationMessageProps {
    message: string
}

// Simple field validation message without icon
const ValidationMessage: React.FC<ValidationMessageProps> = ({ message }) => {
    if (!message) return null
    return <div className={style.fieldErrorMessage}>{message}</div>
}

// Global error message component without icon
export const GlobalErrorMessage: React.FC<{ message: string | null }> = ({
    message,
}) => {
    if (!message) return null
    return <div className={style.errorMessage}>{message}</div>
}

export default ValidationMessage
